import React from 'react';
import {useNavigate} from "react-router-dom";

const BackToDashboard = () => {

    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/dashboard');
    }

    return (
        <div className="cursor-pointer hover:underline inline-block" onClick={handleBack}>INDIETRO</div>
    );
};

export default BackToDashboard;